import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DashboardHeader from "../Components/DashboardHeader/DashboardHeader";
import SettingsMain from "../Components/Settings/SettingsMain";
import { screenSizes } from "../Constants/defaults";
import { useWindowDimensions } from "../Misc/windowDimenstions";
import ScreenContext, { ScreenType } from "../themeContext/ScreenContext";
import Dashboard from "./dashboard";
import Main from "./main";
import NewMachine from "./newMachine";

const AppLayout: React.FC = () => {
  const [screenSizeClassname, setScreenSizeClassname] = useState<ScreenType>("lg");
  const windowDimensions = useWindowDimensions();

  useEffect(() => {
    if (windowDimensions.width <= screenSizes.mobileScreen) {
      setScreenSizeClassname("sm");
    } else if (windowDimensions.width > screenSizes.desktopScreen) {
      setScreenSizeClassname("xl");
    } else {
      setScreenSizeClassname("lg");
    }
  }, [windowDimensions]);

  return (
    <ScreenContext.Provider value={screenSizeClassname}>
      <Router>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="dashboard" element={<DashboardHeader />}>
            <Route path="" element={<Dashboard />} />
            <Route path="new-machine" element={<NewMachine />} />
            <Route path="account" element={<SettingsMain activeTab="account" />} />
            <Route path="subscription" element={<SettingsMain activeTab="subscription" />} />
            <Route path="machines" element={<SettingsMain activeTab="machines" />} />
            <Route path="groups" element={<SettingsMain activeTab="groups" />} />
          </Route>
        </Routes>
      </Router>
    </ScreenContext.Provider>
  );
};

export default AppLayout;
